import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, Router } from '@angular/router';
import { Observable, of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { AuthService } from '../services/auth.service';
import Swal from 'sweetalert2';

@Injectable({
  providedIn: 'root',
})
export class RolePermissionGuard implements CanActivate {
  constructor(private auth: AuthService, private router: Router) {}

  canActivate(route: ActivatedRouteSnapshot): Observable<boolean> {
    const rolesPermitidos = route.data['roles'] as string[] | undefined;
    const permisosRequeridos = route.data['permisos'] as string[] | undefined;
   /*  console.log('RolePermissionGuard:', {
      rolesPermitidos,
      permisosRequeridos
    }); */

    return this.auth.loadProfile().pipe(
      map(user => {
      //  console.log('RolePermissionGuard user:', user);
        if (!user) {
          this.router.navigate(['/auth/login']);
          return false;
        }

     //   console.log('Permisos del usuario:', user.usuario.permisos);

        const tieneRol =
          !rolesPermitidos ||
          rolesPermitidos.some(rol => user.usuario.roles.includes(rol));

        const tienePermiso =
          !permisosRequeridos ||
          permisosRequeridos.some(perm => user.usuario.permisos.includes(perm));
     //   console.log('Comparando permisos:', { permisosRequeridos, permisosUsuario: user.usuario.permisos });
     //   console.log('RolePermissionGuard resultado:', { tieneRol, tienePermiso });

        if (tieneRol && tienePermiso) {
          return true;
        }

        Swal.fire({
          icon: 'warning',
          title: 'Acceso denegado',
          text: 'No tienes permisos para acceder a esta opción.',
          confirmButtonText: 'Aceptar'
        }).then(() => {
          this.router.navigate(['/dashboard/default']);
        });
        return false;
      }),
      catchError(() => {
        this.router.navigate(['/auth/login']);
        return of(false);
      })
    );
  }
}
